export const getOrganizationCreditMetricV86 = (organization = {}) => {
  if (organization.virtual) return null;
  const account = organization.account || {};
  const summary = organization.credit_summary || {};
  if (account.mode === 'prepaid') {
    return {
      amount: summary.available_credit_usd ?? null,
      labelKey: 'organization.table.prepaid_remaining',
    };
  }
  if (account.mode === 'postpaid') {
    return {
      amount: summary.cycle_used_usd ?? null,
      labelKey: 'organization.table.postpaid_used',
    };
  }
  return null;
};
